import {
  Box,
  Button,
  Flex,
  FormLabel,
  Input,
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
  Textarea
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { IBlackList } from '../../../interfaces/BlackList/IBlackList'
import { BlackListService } from '../../../services/BlackList/BlackListService'

interface IBlackListModalProps {
  isOpen: boolean
  onClose: () => void
  data: IBlackList | null
}

export default function BlackListPageModal({ isOpen, onClose, data }: IBlackListModalProps) {
  const service = new BlackListService()
  const toast = useToast()
  const [saving, setSaving] = useState(false)
  const [form, setForm] = useState<Partial<IBlackList>>({
    reason: '',
    email: ''
  })
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})

  useEffect(() => {
    if (data) {
      setForm({
        reason: data.reason,
        email: data.email
      })
    } else {
      setForm({
        reason: '',
        email: ''
      })
    }
    setFormErrors({})
  }, [data, isOpen])

  const handleSave = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    setFormErrors({})
    setSaving(true)
    try {
      if (data?.id) {
        await service.update(data.id, form as IBlackList)
      } else {
        await service.create(form as IBlackList)
      }

      onClose()
    } catch (err) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const error = err as any
      if (error.response?.status === 422) setFormErrors(error.response.data.errors)
      else toast({ title: 'Erro ao salvar e-mail', status: 'error', duration: 3000, isClosable: true })
    } finally {
      setSaving(false)
    }
  }

  return (
    <ChakraModal isOpen={isOpen} onClose={onClose} size="2xl" isCentered scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{data ? 'Editar' : 'Cadastrar'} E-mail</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={handleSave}>
          <ModalBody>
            <Flex direction="column" gap={3}>
              <Box>
                <FormLabel>E-mail</FormLabel>
                <Input
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  disabled={saving}
                />
                {formErrors.email && <Text color="red.500">{formErrors.email}</Text>}
              </Box>
              <Box>
                <FormLabel>Motivação</FormLabel>
                <Textarea
                  value={form.reason ?? ''}
                  onChange={(e) => setForm({ ...form, reason: e.target.value })}
                  disabled={saving}
                />
                {formErrors.reason && <Text color="red.500">{formErrors.reason}</Text>}
              </Box>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" colorScheme="magenta" mr={3} isLoading={saving}>
              Salvar
            </Button>
            <Button type="button" variant="ghost" onClick={onClose} disabled={saving}>
              Cancelar
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </ChakraModal>
  )
}
